// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eEU0x","type":"styles_type__3d67H","choices":"styles_choices__PVonP"};